import { Record } from 'immutable';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import { EMPTY_STRING } from '../constants/SharedConstants';
export const DEFAULT_COMPANY_LOGO_ASPECT_RATIO = 1;
export const DEFAULT_FOOTER_COMPANY_LOGO_HEIGHT = 24;
export const DEFAULT_HEADER_COMPANY_LOGO_HEIGHT = 40;
const KnowledgeBaseSettingsRecord = Record({
  language: EMPTY_STRING,
  companyWebsiteLink: EMPTY_STRING,
  companyWebsiteLinkText: EMPTY_STRING,
  footerCompanyLogo: {
    aspectRatio: DEFAULT_COMPANY_LOGO_ASPECT_RATIO,
    height: DEFAULT_FOOTER_COMPANY_LOGO_HEIGHT,
    src: null
  },
  footerMessage: EMPTY_STRING,
  headerBackground: {
    color: BATTLESHIP,
    backgroundGradientType: undefined,
    backgroundImageSrc: undefined,
    backgroundImageStyle: undefined,
    backgroundPatternSrc: undefined
  },
  headerCompanyLogo: {
    aspectRatio: DEFAULT_COMPANY_LOGO_ASPECT_RATIO,
    height: DEFAULT_HEADER_COMPANY_LOGO_HEIGHT,
    src: null
  },
  name: EMPTY_STRING,
  welcomeMessage: EMPTY_STRING,
  signInLinkEnabled: true,
  customerPortalLinkEnabled: true,
  socialNetworkUrls: [],
  supportFormId: EMPTY_STRING,
  supportFormTitle: EMPTY_STRING,
  footerLinks: []
});
export default KnowledgeBaseSettingsRecord;